export default __webpack_public_path__ + "static/media/subscription2.d88b203c.png";